import React from 'react';
import { useSelector } from 'react-redux';
import { selectHostEditCreateErrorMessage } from 'store/HostEditCreate/selectors';
import { ErrorMessage, TextField, Wrapper } from './styled';

const AssetNameInput = ({ ip, handleChange }) => {
  const errorMessage = useSelector((state) => (selectHostEditCreateErrorMessage(state)));

  const failed = errorMessage && errorMessage.length > 0;

  return (
    <Wrapper>
      <TextField title="Asset*" name="ip" width="145px" placeholder="255.255.255.255" value={ ip } onChange={ (value) => handleChange(value) } className="ip" error={ failed } />
      { failed ? <ErrorMessage> { errorMessage } </ErrorMessage> : null }
    </Wrapper>
  );
};

export default AssetNameInput;
